var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-history-item", on: { click: _vm.handleClick } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "keyword" }, [_vm._v(_vm._s(_vm.keyword))]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("div", { staticClass: "sd2-icons update" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }